import PropTypes from 'prop-types';
import React from 'react';

import SocialLink from '../../../ui/Atoms/SocialLink';

import { Like } from '../../Atoms/Like/Like';

import { Medium } from '../../../shared/constants/Enums';
import * as S from './ShareMenu.styles';

export const ShareMenu = ({
  articleName,
  menuLabel,
  pageUrl,
  handleClick,
  isClicked,
  isHorizontal,
}) => {
  if (!menuLabel || !pageUrl) {
    return null;
  }

  return (
    <S.Menu isHorizontal={isHorizontal}>
      {menuLabel && <S.Title>{menuLabel}</S.Title>}
      {isHorizontal && (
        <S.ButtonWrapper>
          <S.ButtonContainer>
            <SocialLink medium={Medium.FACEBOOK} pageUrl={pageUrl} />
          </S.ButtonContainer>
          <S.ButtonContainer>
            <SocialLink
              articleName={articleName}
              medium={Medium.TWITTER}
              pageUrl={pageUrl}
            />
          </S.ButtonContainer>
          <S.ButtonContainer>
            <SocialLink medium={Medium.LINKEDIN} pageUrl={pageUrl} />
          </S.ButtonContainer>
          {handleClick && (
            <S.ButtonContainer>
              <Like handleClick={handleClick} isClicked={isClicked} />
            </S.ButtonContainer>
          )}
        </S.ButtonWrapper>
      )}
      {!isHorizontal && (
        <>
          <S.ButtonContainer>
            <SocialLink medium={Medium.FACEBOOK} pageUrl={pageUrl} />
          </S.ButtonContainer>
          <S.ButtonContainer>
            <SocialLink
              articleName={articleName}
              medium={Medium.TWITTER}
              pageUrl={pageUrl}
            />
          </S.ButtonContainer>
          <S.ButtonContainer>
            <SocialLink medium={Medium.LINKEDIN} pageUrl={pageUrl} />
          </S.ButtonContainer>
          {handleClick && (
            <S.ButtonContainer>
              <Like handleClick={handleClick} isClicked={isClicked} />
            </S.ButtonContainer>
          )}
        </>
      )}
    </S.Menu>
  );
};

ShareMenu.propTypes = {
  /**
   * Optional article name used for twitter post sharing.
   */
  articleName: PropTypes.string,
  /**
   * Like button function.
   */
  handleClick: PropTypes.func,
  /**
   * Like button state.
   */
  isClicked: PropTypes.bool,
  /**
   * Label at the top of the share menu.
   */
  menuLabel: PropTypes.string.isRequired,
  /**
   * Complete url of the current page.
   */
  pageUrl: PropTypes.string.isRequired,
};
